/**
 * COUPLING: the five replacements below are duplicated, deliberately, at
 * `apps/asgard/gatekeeper-website/src/server/contact/buildContactEmail.ts` — same characters, same
 * entities, same order. That host's Express server is bundled as ESM and run by node, so it cannot
 * load this barrel at all (`contact-form-spam-style-guide.md` → "Server bundle may grow, client
 * bundle may not"); the copy goes when its contact endpoint moves onto the asgard-gatekeeper API.
 * Every other caller in the repo imports this one.
 *
 * Escapes the five HTML-significant characters in a free-text value so it can be
 * interpolated into an HTML document — an outgoing mail body, a rendered fragment —
 * without the value's own markup being parsed. Guards against markup injection from
 * anything a user typed.
 *
 * The apostrophe is escaped as well as the double quote, so the result is also safe
 * inside a single-quoted attribute; `&#39;` and `&#039;` are both valid numeric
 * references for U+0027 and render identically.
 *
 * @param value - The raw free-text value to escape
 * @returns The value with `&`, `<`, `>`, `"` and `'` replaced by their entities
 *
 * @example
 * escapeHtml('<script>alert(1)</script>')
 * // Returns: '&lt;script&gt;alert(1)&lt;/script&gt;'
 */
export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}
